import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const jobPostingsGet = (includeInactive = false) =>
	axios.get(`${apiUrl}ats/job-postings?includeInactive=${!!includeInactive}`);

export const jobPostingGetById = (id) =>
	axios.get(`${apiUrl}ats/job-postings/${id}`);

export const jobPostingCreate = (data) =>
	axios.post(`${apiUrl}ats/job-postings`, data);

export const jobPostingUpdate = (id, data) =>
	axios.put(`${apiUrl}ats/job-postings/${id}`, data);

export const jobPostingDelete = (id) =>
	axios.delete(`${apiUrl}ats/job-postings/${id}`);


